import React from "react";
import { Box, Typography } from "@mui/material";
import InvoiceTable from "./InvoiceTable";

function TabsSection({ 
  onOpenDrawer,
  onOpenManualDrawer,
  highlightedInvoiceId,
  clarificationId,
  onHighlightComplete  
}) {
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h3" 
          sx={{ 
            fontSize: '2.5rem',
            fontWeight: 700,
            background: 'linear-gradient(135deg, #1976d2 0%, #0ea5e9 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 1
          }}
        >
          חשבוניות
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            color: '#6b7280',
            fontSize: '1.1rem'
          }}
        >
          ניהול וקבלת חשבוניות ספקים
        </Typography>
      </Box>

      <InvoiceTable 
        onOpenDrawer={onOpenDrawer}
        onOpenManualDrawer={onOpenManualDrawer}
        highlightedInvoiceId={highlightedInvoiceId}
        clarificationId={clarificationId}
        onHighlightComplete={onHighlightComplete}
      />
    </Box>
  );
}

export default TabsSection;